import React from 'react'
import ImageQualityAuditFooter from '../../views/imageQualityAudit/ImageQualityAuditFooter'

const SideSheetFooter = ({ showImageQualityAudit }) => {
  // Show audit footer if in audit mode
  if (showImageQualityAudit) {
    return <ImageQualityAuditFooter />
  }

  return null
}

export default SideSheetFooter
